import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react'

interface MenuAction {
  icon: IconSvgElement
  label: string
  onClick: () => void
  className?: string
  disabled?: boolean
  separator?: boolean
}

interface DesktopMenuProps {
  menuActions: MenuAction[]
  trigger: React.ReactNode
}

export function DesktopMenu({ menuActions, trigger }: DesktopMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent>
        {menuActions.map((action, index) => {
          return (
            <div key={index}>
              {action.separator && index > 0 && <DropdownMenuSeparator />}
              <DropdownMenuItem
                onClick={action.disabled ? undefined : action.onClick}
                className={action.className}
                disabled={action.disabled}
              >
                <HugeiconsIcon icon={action.icon} />
                {action.label}
              </DropdownMenuItem>
            </div>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
